﻿import { useQuery, useMutation, useQueryClient } from "react-query";
import { useLocation, useNavigate } from "react-router-dom";
import _ from "lodash";

import { getAptitude, getAptitudes, saveAptitud, deleteAptitud, groupAptitud } from "@/api/Maintainers/aptitudes";

const key = "aptitudes";

export function useAptitude(selected) {
	return useQuery([key, selected], () => selected && getAptitude({ selected }));
}

export function useAptitudesPaginate(params) {
	return useQuery([key, params], () => getAptitudes(params));
}

export function useMutateAptitude(params) {
	const navigate = useNavigate();
	const location = useLocation();
	const queryClient = useQueryClient();

	return useMutation(saveAptitud, {
		onSuccess: (response) => {
			const aptitudes = _.omit(response, "detail");
			const aptitude = _.omit(response, key);

			queryClient.setQueryData([key, String(aptitude.detail.id)], aptitude);
			queryClient.setQueryData([key, params], aptitudes);

			if (params.search) {
				queryClient.invalidateQueries([key]);
			}

			if (location.state) {
				navigate(location.state);
				return;
			}

			navigate("/mantenedores/aptitudes");
		},
	});
}

export function useMutateDeleteAptitud(params) {
	const queryClient = useQueryClient();

	return useMutation(deleteAptitud, {
		onSuccess: (response) => {
			queryClient.setQueryData([key, params], response);
		},
	});
}

export function useMutateGroup(params) {
	const queryClient = useQueryClient();

	return useMutation(groupAptitud, {
		onSuccess: (response) => {
			queryClient.setQueryData([key, params], response);
		},
	});
}
